import {
  clearServiceEventSchemaDetails,
  fetchServiceEventSchemaFail,
  fetchServiceEventSchemaStarted,
  fetchServiceEventSchemaSuccess
} from '../../../reducer/services/ServiceEventSchemaReducer';
import {
  ClearServiceEventSchema,
  FetchServiceEventSchemaFailure,
  FetchServiceEventSchemaFailurePayload, FetchServiceEventSchemaStarted,
  FetchServiceEventSchemaSuccess,
  FetchServiceEventSchemaSuccessPayload
} from '../../types/services/GetAllServiceEventSchemaTypes';

/**
 * Fetch service event schema started saga action
 * @returns service event started action
 */
export const getServiceEventSchemaStarted = (): FetchServiceEventSchemaStarted => ({
  type: fetchServiceEventSchemaStarted.type
});

/**
 * Fetch service event schema success saga action
 * @param payload : Service Event schema data
 * @returns success action
 */
export const getServiceEventSchemaSuccess = (
  payload: FetchServiceEventSchemaSuccessPayload
): FetchServiceEventSchemaSuccess => ({
  type: fetchServiceEventSchemaSuccess.type,
  payload
});

/**
 * Fetch Service Event schema Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchServiceEventSchemaFailure = (
  payload: FetchServiceEventSchemaFailurePayload
): FetchServiceEventSchemaFailure => ({
  type: fetchServiceEventSchemaFail.type,
  payload
});

/**
 * Clear Service Events Schema saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearServiceEventSchema = (): ClearServiceEventSchema => ({
  type: clearServiceEventSchemaDetails.type
});
